import { Component, Event, EventEmitter, Host, Method, Prop, h } from '@stencil/core';

@Component({
  tag: 'sy-site-alert-modal',
  styleUrl: 'sy-site-alert-modal.scss',
  shadow: true,
})
export class SySiteAlertModal {
  /**
   * Dialog title
   */
  @Prop() dialogTitle: string;

  /**
   * Dialog message
   */
  @Prop() dialogMessage: string;

  private dialog: HTMLSyDialogElement;

  /**
   * Shows the modal
   */
  @Method()
  async open(): Promise<void> {
    this.dialog.open();
  }

  /**
   * Emmitted when sy-dialog is closed
   */
  @Event({ bubbles: true, composed: true }) sySiteAlertModalDidClose: EventEmitter<string>;

  private emitSySiteAlertModalDidClose(event: CustomEvent): void {
    this.sySiteAlertModalDidClose.emit(event.detail);
  }

  render() {
    return (
      <Host>
        <sy-dialog
          position="unset"
          hideFooter
          ref={(el) => (this.dialog = el)}
          hideClose
          onSyDialogDidClose={(e) => this.emitSySiteAlertModalDidClose(e)}
        >
          <div class="dialog-content">
            <sy-text type="h4">{this.dialogTitle}</sy-text>
            <sy-text type="body">{this.dialogMessage}</sy-text>
          </div>
        </sy-dialog>
      </Host>
    );
  }
}
